<template>
  <div class="product-all-box">
    <div class="product-top-box">
      <div class="top-title">职业教育服务体系</div>
      <div class="tips-txt">按F11切换至全屏模式效果更佳</div>
      <div class="right-split"></div>
      <div class="right-logout" @click="logoutEvents">退出</div>
    </div>

    <div class="unit-line-box top0">
      <div class="unit-title">立德树人</div>
      <!-- <div class="unit-case" @click="previewWord('立德树人')">综合服务方案</div> -->
    </div>

    <div class="first-con-box">
      <div class="first-con-item one">
        <div class="one-title">
          <div class="one-title-left">大思政课</div>
          <div class="one-title-right" @click="previewWord('大思政课','https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/411003e0e363a1d0d8fa2e58d7366925.pdf')"><span>服务介绍</span></div>
        </div>
        <div class="first-list-box">
          <div v-for="item,index in dasizhengData" :key="index" class="list-item">
            <div class="item-cover" :style=" `background-image: url(${item.img});`"></div>
            <div class="item-label">{{item.title}}</div>
            <div class="item-btn">
              <a v-if="item.type == 'url'" :href="item.url" target="_blank" class="btn-opt">{{item.btnTxt}}</a>
              <div v-else @click="previewWord(item.title, item.url)" class="btn-opt">{{item.btnTxt}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="first-con-item two">
        <div class="one-title">
          <div class="one-title-left">课程思政</div>
          <div class="one-title-right" @click="previewWord('课程思政','https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/30f77494f216f46d374e3566e408afb7.pdf')"><span>服务介绍</span></div>
        </div>
        <div class="first-list-box">
          <div v-for="item,index in kcszData" :key="index" class="list-item">
            <div class="item-cover" :style=" `background-image: url(${item.img});`"></div>
            <div class="item-label">{{item.title}}</div>
            <div :class="['item-btn', menuOpen ? 'up' : 'down']" @mouseleave="onMenuMouse('menuOpen',false)">
              <a v-if="item.type == 'url'" @click="checkMobileLink(item, item.id,'kcszData')" class="btn-opt">{{item.btnTxt}}</a>
              <div v-else-if="item.type == 'word'" @click="previewWord(item.title)" class="btn-opt">{{item.btnTxt}}</div>
              <template v-else>
                <div @mouseenter="onMenuMouse('menuOpen',true)" class="btn-opt subicon">{{item.btnTxt}}</div>
                <ul v-if="item.dorpArr && item.dorpArr.length > 0" class="eol-submine-box">
                  <li v-for="(subItem, sindex) in item.dorpArr" :key="sindex" class="submine-items">
                    <a :href="subItem.url" target="_blank">{{subItem.name}}</a>
                  </li>
                </ul>
              </template>
            </div>
          </div>

        </div>
      </div>
      <div class="first-con-item three">
        <div class="one-title">
          <div class="one-title-left">实践育人</div>
        </div>
        <div class="first-list-box">
          <div class="list-item">
            <div class="item-cover" :style="`background-image: url(${require('../../assets/imgs/product/icon/jdjs.png')});`"></div>
            <div class="item-label">实践育人</div>
            <div class="item-btn">
              <a class="btn-opt" @click="previewWord('实践育人','https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/10207933c0962e4e7e4656d6ecf55a30.pdf')">服务介绍</a>
              <!-- <a class="btn-opt">案例展示</a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="first-con-item four">
        <div class="one-title">
          <div class="one-title-left">党员培训</div>
        </div>
        <div class="first-list-box">
          <div class="list-item">
            <div class="item-cover" :style="`background-image: url(${require('../../assets/imgs/product/icon/dypx.png')});`"></div>
            <div class="item-label">党员培训</div>
            <div class="item-btn">
              <a class="btn-opt" @click="previewWord('党员培训','https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/275badf48dc6cdcc66d2d94f4a30ac2f.pdf')">产品介绍</a>
              <a class="btn-opt" href="https://xuexi.jiaoyu.cn/center/100004/custom/party" target="_blank">平台演示</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="unit-level-box">
      <div class="unit-title one">校园融媒及宣传</div>
      <!-- <div class="unit-title">宣传推广</div> -->
      <div class="unit-title">职教出海</div>
    </div>
    <div class="second-con-box">
      <div class="second-con-item one">
        <div class="one-title">
          <div class="one-title-left">网络思政融媒体中心</div>
          <div class="one-title-right" @click="previewWord('网络思政融媒体中心','https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/3cf94ba8c17efbd8279bd076723038cc.pdf')"><span>服务介绍</span></div>
        </div>
        <div class="second-list-box">
          <div v-for="item,index in rmtData" :key="index" class="list-item">
            <div class="item-cover" :style=" `background-image: url(${item.img});`"></div>
            <div class="item-label">{{item.title}}</div>
            <div :class="['item-btn', secondOpen ? 'up' : 'down']" @mouseleave="onMenuMouse('secondOpen',false)">
              <div @click="previewWord(item.title, item.word)" class="btn-opt">服务介绍</div>
              <div v-if="item.id == 4" @mouseenter="onMenuMouse('secondOpen',true)" class="btn-opt subicon">{{item.btnTxt}}</div>
              <a v-else @click="checkMobileLink(item,item.id, 'rmtData')" class="btn-opt">{{item.btnTxt}}</a>
              <template v-if="item.type == 'drop'">
                <ul v-if="item.dorpArr && item.dorpArr.length > 0" class="eol-submine-box">
                  <li v-for="(subItem, sindex) in item.dorpArr" :key="sindex" class="submine-items">
                    <a :href="subItem.url" target="_blank">{{subItem.name}}</a>
                  </li>
                </ul>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="second-con-item three">
        <div class="one-title">
          <div class="one-title-left">宣传推广</div>
        </div>
        <div class="second-list-box">
          <div class="list-item">
            <div class="item-cover" :style="`background-image: url(${require('../../assets/imgs/product/icon/xctg.png')});`"></div>
            <div class="item-label">宣传推广</div>
            <div class="item-btn">
              <a class="btn-opt" @click="previewWord('宣传推广')">服务介绍</a>
            </div>
          </div>
        </div>
      </div>

      <div class="unit-line-box zhijiaoH5">
        <div class="unit-title">职教出海</div>
      </div>
      <div class="second-con-item four">
        <div class="one-title">
          <div class="one-title-left">职教出海</div>
        </div>
        <div class="second-list-box">
          <div class="list-item">
            <div class="item-cover" :style="`background-image: url(${require('../../assets/imgs/product/icon/zjch.png')});`"></div>
            <div class="item-label">职教出海</div>
            <div class="item-btn">
              <a class="btn-opt purple" @click="previewWord('职教出海', 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/10/de713c0b487492e0d8f60161add73a7a.pdf')">服务介绍</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="unit-line-box">
      <div class="unit-title">专业建设</div>
    </div>
    <div class="third-con-box">
      <div class="third-con-item">
        <div class="one-title">
          <div class="one-title-left">融媒体技术与运营专业群</div>
          <div class="one-title-right"><span>综合服务方案</span></div>
        </div>
        <div class="third-list-box">
          <div v-for="item,index in zyjsData" :key="index" class="list-item">
            <div class="item-cover" :style=" `background-image: url(${item.img});`"></div>
            <div class="item-label">{{item.title}}</div>
            <div class="item-btn">
              <template v-for="sub,sinx in item.btnArr">
                <div v-if="sub.type == 'word'" :key="sinx" @click="previewWord(item.title, sub.url)" class="btn-opt">{{sub.name}}</div>
                <div v-else-if="sub.type == 'video'" :key="sinx" @click="previewVideo(item.title, sub.url)" class="btn-opt">{{sub.name}}</div>
                <a v-else @click="checkMobileLink(sub, item.id, 'zyjsData')" :key="sinx" class="btn-opt">{{sub.name}}</a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载中进度 -->
    <div v-show="downloadShow" class="el-loading-mask is-fullscreen" style="background-color: rgba(255, 255, 255, 0.9); z-index: 2001;">
      <div class="el-loading-spinner">
        <i class="el-icon-loading"></i>
        <p class="el-loading-text">加载中</p>
      </div>
    </div>

    <component :is="dialogConfig.name" @closeBox="closePlayBox" :dialogConfig="dialogConfig"></component>
  </div>
</template>


<script>
// import VueBaseDialog from "@/components/VueBaseDialog";
import { mapActions } from "vuex";
import services from '../../assets/js/services'
import axios from 'axios';
import utils from "@/assets/js/utils.js"
axios.defaults.withCredentials = true;  //允许跨域携带cookies
export default {
  name: "ProductList",
  components: {
    PreviewPdf: () => import('../../components/PreviewPdf'),
    PlayBox: () => import('../../components/PlayBox'),
    ShowPdf: () => import('../../components/ShowPdf.vue'),
  },
  data () {
    return {
      utils,
      downloadShow: false,
      school_code: localStorage.getItem('schoolCode'),
      services,
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      menuOpen: false,
      secondOpen: false,
      // 大思政课
      dasizhengData: [

        {
          id: 2,
          title: '智慧思政教研',
          img: require('../../assets/imgs/product/icon/zhszjy.png'),
          url: 'https://kcsz.jiaoyu.cn/100004/zy/szktz',
          type: 'url',
          btnTxt: '资源展示'
        },
        {
          id: 3,
          title: '思政实践教学',
          img: require('../../assets/imgs/product/icon/szsjjx.png'),
          url: 'https://zhsz.jiaoyu.cn/100004/shijian/',
          type: 'url',
          btnTxt: '系统演示'
        },
        {
          id: 4,
          title: '思政虚拟仿真',
          img: require('../../assets/imgs/product/icon/szxnfz.png'),
          type: 'word',
          url: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/0e964682991d1adcba6a976a98f4b013.pdf',
          btnTxt: '服务介绍'
        },
        {
          id: 1,
          title: '思政教师培训',
          img: require('../../assets/imgs/product/icon/szjspx.png'),
          url: 'https://kcsz.jiaoyu.cn/100004/zy/xxzyk/szztyx',
          type: 'url',
          btnTxt: '资源展示'
        },
      ],
      // 课程思政
      kcszData: [
        {
          id: 2,
          title: '课程思政资源平台',
          img: require('../../assets/imgs/product/icon/kcszzypt.png'),
          url: 'https://kcsz.jiaoyu.cn/100004/zy',
          btnTxt: '资源库展示',
          type: 'url',
        },
        {
          id: 3,
          title: '在线备课平台',
          img: require('../../assets/imgs/product/icon/zxbkpt.png'),
          url: 'https://bk.jiaoyu.cn/100004/lesson/resource',
          btnTxt: '系统演示',
          type: 'url',
        },
        {
          id: 4,
          title: '成果展示',
          img: require('../../assets/imgs/product/icon/cgzs.png'),
          url: '',
          btnTxt: '合作案例',
          type: 'drop',
          dorpArr: [
            { id: 1, name: '山东传媒职业技术学院课程思政云平台 ', url: 'https://kcsz.jiaoyu.cn/100017/' },
            { id: 2, name: '武汉软件工程职业技术学院课程思政云平台', url: 'https://zhsz.jiaoyu.cn/100024/' },
            { id: 3, name: '浙江工商职业技术学院 思政资源库', url: 'https://kcsz.jiaoyu.cn/100023/zy' },
            { id: 4, name: '甘肃林业职业技术学院 思政资源库', url: 'https://kcsz.jiaoyu.cn/100031/zy' },
            { id: 5, name: '广州科技贸易职业学院 课程思政研究中心', url: 'https://zhijiao.eol.cn/gzkmu/index.html' },
            { id: 6, name: '扬州市职业大学 课程思政教学研究中心', url: 'https://zhsz.jiaoyu.cn/100047/10/index.html' },
            // { id: 7, name: '河北威县职业技术教育中心 思政资源库', url: 'https://kcsz.jiaoyu.cn/100050/zy' },
            { id: 8, name: '云南机电职业技术学院 思政数字云库', url: 'https://kcsz.jiaoyu.cn/100048/zy' },
            { id: 9, name: '甘肃工业职业技术学院 课程思政教学研究中心', url: 'https://zhsz.jiaoyu.cn/100056/kcsz/index.html' },
            { id: 10, name: '四川财经职业学院 思政资源库', url: 'https://kcsz.jiaoyu.cn/100055/sccj' },
          ]
        },
        {
          id: 1,
          title: '教师培训',
          img: require('../../assets/imgs/product/icon/jspx.png'),
          url: 'https://kcsz.jiaoyu.cn/100004/zy/xxzyk/kcszzt',
          btnTxt: '资源展示',
          type: 'url',
        },
      ],
      // 网络思政融媒体中心
      rmtData: [
        {
          id: 1,
          title: '融媒体运营管理系统',
          img: require('../../assets/imgs/product/icon/rmtyyglxt.png'),
          url: 'https://qmt.jiaoyu.cn/100004',
          btnTxt: '系统演示',
          word: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/df5df24eb372a632102986089bd59172.pdf'
        },
        {
          id: 2,
          title: '舆情监测系统',
          img: require('../../assets/imgs/product/icon/yqjcxt.png'),
          url: 'https://yq.eol.cn/api/index',
          btnTxt: '系统演示',
          word: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/f5c39266ab4bb3f2598c9ebb48e62a69.pdf'
        },
        {
          id: 3,
          title: '智能风险巡检系统',
          img: require('../../assets/imgs/product/icon/znfxxjxt.png'),
          url: 'https://ai.jiaoyu.cn/100004',
          btnTxt: '系统演示',
          word: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/eb41f8da9e361b726fec7f2f7cdb0a9a.pdf'
        },
        {
          id: 4,
          title: '网络思政育人平台',
          img: require('../../assets/imgs/product/icon/wlyrpt.png'),
          url: 'https://qmt.jiaoyu.cn/100004',
          btnTxt: '案例展示',
          word: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/04/09/061836d806eab51396d7c8224302207f.pdf',
          type: 'drop',
          dorpArr: [
            { id: 1, name: '杭州职业技术学院-党建与思政教育资源平台', url: 'https://xuexi.jiaoyu.cn/center/100028/hzvtc' },
            { id: 2, name: '江苏旅游职业学院-网络思政育人平台', url: 'https://zhsz.jiaoyu.cn/100052/11/' },
            { id: 3, name: '云南机电-信息工程学院-思政育人平台', url: 'https://zhsz.jiaoyu.cn/100048/12/index.html' },
            { id: 4, name: '甘肃工业职业技术大学-大思政育人云平台', url: 'https://zhsz.jiaoyu.cn/100056/wlsz/index.html' },
            { id: 5, name: '重庆工商职业学院-红岩思政育人云平台', url: 'https://zhsz.jiaoyu.cn/100063/wlsz/index.html' },
            { id: 6, name: '苏州农业职业技术学院-大思政育人云平台', url: 'https://zhsz.jiaoyu.cn/100058/wlsz' }
          ]
        },
      ],
      zyjsData: [ // 专业建设数据
        {
          id: 1,
          title: '教学资源',
          img: require('../../assets/imgs/product/icon/jxzy.png'),
          btnArr: [
            { id: 1, name: '资源介绍', type: 'word', url: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/05/30/94ddcf80a2baed823c32d108757efd3c.pdf' },
            { id: 2, name: '资源展示', type: 'url', url: 'https://xuexi.jiaoyu.cn/school/100004/SpecialCourse/index' },
          ]
        },
        {
          id: 2,
          title: '技能实训平台',
          img: require('../../assets/imgs/product/icon/jnsxpt.png'),
          btnArr: [
            { id: 1, name: '平台介绍', type: 'word', url: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/05/30/1ed92ee86483af6e68969a6d8db7954a.pdf' },
            { id: 2, name: '视频介绍', type: 'video', url: '1397757899922267832' },
            { id: 3, name: '系统演示', type: 'url', url: 'https://shixun.jiaoyu.cn/100004' },
          ]
        },
        {
          id: 3,
          title: '综合实训平台',
          img: require('../../assets/imgs/product/icon/zhsxpt.png'),
          btnArr: [
            { id: 1, name: '平台介绍', type: 'word', url: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/05/30/abb11e4003c4e133116a4331269f814b.pdf' },
            { id: 2, name: '视频介绍', type: 'video', url: '1397757899922681618' },
            { id: 3, name: '系统演示', type: 'url', url: 'https://rmt.jiaoyu.cn/100004/train/center', },
          ]
        },
        {
          id: 4,
          title: '培训服务',
          img: require('../../assets/imgs/product/icon/pxfw.png'),
          btnArr: [
            { id: 1, name: '服务介绍', type: 'word', url: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/05/30/b4d573a2de0b2247d083c0347aa0a37a.pdf' }
          ]
        },
        {
          id: 5,
          title: '证书服务',
          img: require('../../assets/imgs/product/icon/zsfw.png'),
          btnArr: [
            { id: 1, name: '服务介绍', type: 'word', url: 'https://xuexi-api.jiaoyu.cn/uploads/material/2025/05/30/0da9a4d8c036419c08050db5ba4a4165.pdf' },
            { id: 2, name: '证书资源', type: 'url', url: 'https://xuexi.jiaoyu.cn/school/100004/Purchase/PurchaseMaterials' }
          ]
        },

      ]
    };
  },
  mounted () {
    window.onresize = this.setfontSize; // 窗口大小改变时重新设置rem值
    this.setfontSize(); // 初始化时设置一次rem值
  },
  created () {
    this.methodLoginUserInfo()
  },
  methods: {
    ...mapActions(['getLoginUserInfo', "requestLogout",]),
    onMenuMouse (key, val) {
      this[key] = val
    },
    checkMobileLink (item, id, dataname) {
      if (this.utils.isMobile()) {
        if ((dataname == 'kcszData' && id == 3) || (dataname == 'zyjsData' && (id == 2 || id == 3)) || (dataname == 'rmtData' && (id == 2 || id == 3))) {
          this.$warningMsg("仅支持电脑端访问")
        } else {
          window.open(item.url, "_blank")
        }
      } else {
        window.open(item.url, "_blank")
      }

    },
    // 获取用户信息
    methodLoginUserInfo () {
      let that = this
      that.getLoginUserInfo({ is_append: 1 })
    },

    setfontSize () {
      let html = document.getElementsByTagName("html");
      var size;
      var winW = document.documentElement.clientWidth || window.innerWidth;

      if (winW <= 1600 && winW > 800) {
        size = Math.round(winW / 16);
      } else if (winW <= 800) {
        size = 100;
        // size = Math.round(winW / 7.5);
        // if (size > 65) {
        //   size = 65;
        // }
      } else {
        size = 100;
      }
      html[0].style.fontSize = size + "px";
    },
    closePlayBox () {
      // this.getTaskData()
    },
    previewWord (title, path) {
      let that = this
      if (path) {
        that.dialogConfig.title = title
        that.dialogConfig.type = 4
        that.dialogConfig.path = path
        that.dialogConfig.name = 'ShowPdf';

        // that.downloadShow = true
        // // 无论测试、正式线 api和预览域名均使用正式线地址
        // axios({
        //   // url: that.services.XUEXI_API_SERVER + '/api/apps/material/download?url=' + path,
        //   url: 'https://xuexi-api.jiaoyu.cn/api/apps/material/download?url=' + path,
        //   method: 'get',
        //   responseType: 'blob',
        // }).then(res => {
        //   console.log(res)
        //   // that.downloadShow = false
        //   if (res.status == 200 && res.data) {
        //     that.dialogConfig.loading =  false
        //     let file_url = that.getObjectURL(res.data)
        //     that.dialogConfig.path = file_url
        //     // that.dialogConfig.path = `${window.location.origin}/pdf/web/viewer.html?file=${encodeURIComponent(file_url)}`
        //     // that.dialogConfig.name = 'PreviewPdf';
        //   } else {
        //     that.$errorMsg("文件预览失败")
        //   }
        // }).catch(() => {
        //   // that.downloadShow = false
        //   that.dialogConfig.loading =  false
        // })
      } else {
        that.$warningMsg("建设中")
      }
    },
    previewVideo (title, fileID) {
      if (fileID) {
        this.dialogConfig.title = title
        this.dialogConfig.fileId = fileID
        this.dialogConfig.name = 'PlayBox';
      }
    },
    // 将返回的文件流转换为url
    getObjectURL (data) {
      var url = null
      if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(data)
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(data)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) { // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(data)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    // 退出登录
    logoutEvents () {
      let that = this
      this.requestLogout().then(res => {
        if (res.code == '0000') {
          let code = localStorage.getItem('schoolCode')
          if (!res.data || !res.data.redirect) {
            if (code) {
              that.$router.push({ path: `/${code}/login` })
            } else {
              that.$router.push({ path: '/login' })
            }
          }
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.product-all-box .eol-submine-box {
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(87, 87, 87, 0.1);
    border: 1px solid #dee5ec;
    position: absolute;
    z-index: 1000;
    top: 30px;
    left: 0;
    padding: 18px 0;
    text-align: left;
    display: none;
    max-width: max-content;
    min-width: 90px;
    .submine-items {
        color: #42464c;
        font-size: 14px;
        cursor: pointer;
        display: block;
        a {
            display: block;
            width: auto;
            color: #71737b;
            white-space: nowrap;
            padding: 0 20px;
            height: 38px;
            line-height: 38px;
        }
        &:hover a {
            color: #ed8625;
            text-decoration: none;
            background-color: #fafafa;
        }
    }
}
.product-all-box .item-btn .btn-opt.subicon::before {
    content: '';
    display: inline-block;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 4px;
}
.product-all-box .item-btn .btn-opt.subicon::after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 4px;
    // border: 4px solid transparent;
    border-left: 3px solid transparent; /* 左边框透明 */
    border-right: 3px solid transparent; /* 右边框透明 */
    border-top: 6px solid #ed8625; /* 上边框为黑色 */
}
.product-all-box .item-btn.up .btn-opt.subicon::after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
}

.product-all-box .item-btn.down .btn-opt.subicon::after {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
}
.product-all-box .item-btn.up .eol-submine-box {
    display: block;
}
.product-all-box .item-btn.down .eol-submine-box {
    display: none;
}

.product-all-box .second-con-box .item-btn .btn-opt.subicon::after {
    border-top-color: #3a81ff;
}
.product-all-box
    .second-con-box
    .item-btn
    .eol-submine-box
    .submine-items:hover
    a {
    color: #3a81ff;
    text-decoration: none;
}
.product-all-box {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding-bottom: 0.2rem;
    box-sizing: border-box;
    position: relative;
    background: url('../../assets/imgs/product/big-bg.jpg') no-repeat center
        center;
    background-size: cover;
    .product-top-box {
        position: relative;

        width: 100%;
        height: 1.01rem;
        background: url('../../assets/imgs/product/title.png') no-repeat center
            center;
        background-size: cover;
        .top-title {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 0.3rem;
            position: absolute;
            left: 50%;
            top: 31%;
            transform: translate(-50%, -50%);
            color: #ffffff;
        }
        .tips-txt {
            font-size: 0.14rem;
            color: #4b6db6;
            position: absolute;
            top: 31%;
            right: 0.7rem;
            transform: translate(0, -50%);
        }
        .right-split {
            height: 0.12rem;
            width: 1px;
            background-color: #4b6db6;
            position: absolute;
            top: 31%;
            right: 0.62rem;
            transform: translate(0, -50%);
        }
        .right-logout {
            font-size: 0.14rem;
            color: #4b6db6;
            position: absolute;
            top: 31%;
            right: 0.28rem;
            transform: translate(0, -50%);
            cursor: pointer;
        }
    }
    .unit-line-box {
        width: 100%;
        padding: 0.25rem 0.28rem;
        box-sizing: border-box;
        text-align: left;
        &.zhijiaoH5 {
            display: none;
        }
        &.top0 {
            padding-top: 0;
        }
        .unit-title {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 0.22rem;
            color: #1d2c3d;
            display: inline-block;
        }
        .unit-case {
            width: 1.14rem;
            height: 0.22rem;
            line-height: 0.22rem;
            text-align: center;

            border-radius: 0.04rem;
            font-weight: bold;
            font-size: 0.14rem;
            color: #125cfd;
            display: inline-block;
            margin-left: 0.23rem;
            cursor: pointer;
            &::after {
                content: '';
                display: inline-block;
                width: 0.06rem;
                height: 0.06rem;
                background: #fff url('../../assets/imgs/product/jiantou.png')
                    no-repeat center center;
                background-size: cover;
                margin-left: 0.05rem;
            }
            &:hover {
                background: rgba(255, 255, 255, 0.68);
            }
        }
    }

    .unit-level-box {
        width: 100%;
        padding: 0.25rem 0.28rem;
        box-sizing: border-box;
        text-align: left;
        display: flex;
        justify-content: space-between;
        .unit-title {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 0.22rem;
            color: #1d2c3d;
            display: inline-block;
            width: 15.3%;
            &.one {
                width: 67%;
            }
        }
    }

    .first-con-box {
        width: 100%;
        padding: 0 0.28rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .first-con-item {
            .one-title {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 0.12rem;
                margin-bottom: 0.18rem;
                .one-title-left {
                    width: 73.6%;
                    background: url('../../assets/imgs/product/first-left-title.png')
                        no-repeat left center;
                    background-size: auto 100%;
                    font-weight: bold;
                    font-size: 0.16rem;
                    color: #293950;
                    padding-left: 0.36rem;
                    text-align: left;
                    height: 0.36rem;
                    line-height: 0.36rem;
                    box-sizing: border-box;
                }
                .one-title-right {
                    span {
                        display: inline-block;
                        width: 0.64rem;
                        height: 0.2rem;
                        background: linear-gradient(
                            0deg,
                            #f3c496 0%,
                            #f19742 100%
                        );
                        border-radius: 0.02rem;
                        text-align: center;
                        line-height: 0.2rem;
                        font-weight: 400;
                        font-size: 0.13rem;
                        color: #ffffff;
                        cursor: pointer;
                        &:hover {
                            background: #f19742;
                        }
                    }
                }
            }
            .first-list-box {
                display: flex;
                justify-content: space-between;
                padding: 0 0.2rem 0.2rem;
                .list-item {
                    width: 24.3%;
                    // padding: 0.2rem 0 0.24rem;
                    height: 1.77rem;
                    background: rgba(255, 255, 255, 0.7);
                    border-radius: 0.08rem;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .item-cover {
                        width: 0.44rem;
                        height: 0.44rem;
                        background-image: url('../../assets/imgs/product/first-left-title.png');
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: 100% auto;
                    }
                    .item-label {
                        font-weight: bold;
                        font-size: 0.16rem;
                        color: #293950;
                        padding: 0.2rem 0.05rem;
                    }
                    .item-btn {
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;
                        width: 100%;
                        position: relative;
                        .btn-opt {
                            width: 0.96rem;
                            height: 0.26rem;
                            background: #ffffff;
                            border-radius: 0.13rem;
                            border: 1px solid #f6e5d4;
                            font-size: 0.14rem;
                            text-align: center;
                            line-height: 0.26rem;
                            color: #ed8625;
                            cursor: pointer;
                            &:hover {
                                background: #fff4e8;
                            }
                        }
                    }
                }
            }
            &.one,
            &.two {
                width: 33%;
                background: url('../../assets/imgs/product/first-left-bg.png')
                    no-repeat center center;
                background-size: cover;
                box-shadow: 0px 0px 12px 0px rgba(87, 87, 87, 0.1);
                border: 1px solid #fff;
                .one-title-right {
                    &::after {
                        content: '';
                        display: inline-block;
                        width: 0.1rem;
                        height: 0.1rem;
                        background: transparent;
                        margin-left: 0.09rem;
                    }
                }
            }
            &.two {
                .first-list-box {
                    .list-item {
                        width: auto;
                        min-width: 23%;
                    }
                }
            }
            &.three,
            &.four {
                width: 15.3%;
                background: url('../../assets/imgs/product/first-right-bg.png')
                    no-repeat center center;
                background-size: cover;
                box-shadow: 0px 0px 12px 0px rgba(87, 87, 87, 0.1);
                border: 1px solid #fff;
                .one-title {
                    width: 100%;
                    .one-title-left {
                        width: 92%;
                        background: url('../../assets/imgs/product/first-right-title.png')
                            no-repeat left center;
                        background-size: auto 100%;
                    }
                }
                .first-list-box {
                    .list-item {
                        width: 100%;
                        .item-btn {
                            .btn-opt {
                                width: 0.92rem;
                            }
                        }
                    }
                }
            }
        }
    }

    .second-con-box {
        width: 100%;
        padding: 0 0.28rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .second-con-item {
            box-shadow: 0px 0px 12px 0px rgba(87, 87, 87, 0.1);
            border: 1px solid #fff;
            .one-title {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 0.12rem;
                margin-bottom: 0.18rem;
                .one-title-left {
                    width: 73.6%;
                    background: url('../../assets/imgs/product/second-left-title.png')
                        no-repeat left center;
                    background-size: auto 100%;
                    font-weight: bold;
                    font-size: 0.16rem;
                    color: #293950;
                    padding-left: 0.36rem;
                    text-align: left;
                    height: 0.36rem;
                    line-height: 0.36rem;
                    box-sizing: border-box;
                }
                .one-title-right {
                    span {
                        display: inline-block;
                        width: 0.64rem;
                        height: 0.2rem;
                        background: linear-gradient(182deg, #78a7ff, #367fff);
                        border-radius: 0.02rem;
                        text-align: center;
                        line-height: 0.2rem;
                        font-weight: 400;
                        font-size: 0.13rem;
                        color: #ffffff;
                        cursor: pointer;
                        margin-right: 0.2rem;
                        &:hover {
                            background: #1e78ea;
                        }
                    }
                }
            }
            .second-list-box {
                display: flex;
                justify-content: space-between;
                padding: 0 0.2rem 0.2rem;
                flex: 1;
                .list-item {
                    width: 23.9%;
                    padding: 0.2rem 0 0.24rem;
                    background: rgba(255, 255, 255, 0.7);
                    border-radius: 0.08rem;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .item-cover {
                        width: 0.44rem;
                        height: 0.44rem;
                        background-image: url('../../assets/imgs/product/first-left-title.png');
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: 100% auto;
                    }
                    .item-label {
                        font-weight: bold;
                        font-size: 0.16rem;
                        color: #293950;
                        padding: 0.2rem;
                    }
                    .item-btn {
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;
                        position: relative;
                        width: 100%;
                        .btn-opt {
                            width: 0.96rem;
                            height: 0.26rem;
                            background: #ffffff;
                            border-radius: 0.13rem;
                            border: 1px solid #c6dfff;
                            font-size: 0.14rem;
                            text-align: center;
                            line-height: 0.26rem;
                            color: #3a81ff;
                            cursor: pointer;
                            &.purple {
                                color: #3948e5;
                                border: 1px solid #c4d2fd;
                            }
                            &:hover {
                                background: #e4f1ff;
                            }
                            &.purple:hover {
                                background: #e1e8fe;
                            }
                        }
                    }
                }
            }
            &.one {
                width: 67%;
                background: url('../../assets/imgs/product/second-left-bg.png')
                    no-repeat center center;
                background-size: cover;
            }
            &.three {
                width: 15.3%;
                background: url('../../assets/imgs/product/second-middle-bg.png')
                    no-repeat center center;
                background-size: cover;
                .one-title {
                    width: 100%;
                    .one-title-left {
                        width: 92%;
                        background: url('../../assets/imgs/product/scond-middle-title.png')
                            no-repeat left center;
                        background-size: auto 100%;
                    }
                }
                .second-list-box {
                    .list-item {
                        width: 100%;
                        .item-btn {
                            .btn-opt {
                                width: 0.92rem;
                            }
                        }
                    }
                }
            }
            &.four {
                width: 15.3%;
                background: url('../../assets/imgs/product/second-right-bg.png')
                    no-repeat center center;
                background-size: cover;
                .one-title {
                    width: 100%;
                    .one-title-left {
                        width: 92%;
                        background: url('../../assets/imgs/product/second-right-title.png')
                            no-repeat left center;
                        background-size: auto 100%;
                    }
                }
                .second-list-box {
                    .list-item {
                        width: 2.54rem;
                        .item-btn {
                            .btn-opt {
                                width: 0.92rem;
                            }
                        }
                    }
                }
            }
        }
    }

    .third-con-box {
        width: 100%;
        padding: 0 0.28rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .third-con-item {
            width: 100%;
            background: url('../../assets/imgs/product/third-bg.png') no-repeat
                center center;
            background-size: cover;
            box-shadow: 0px 0px 12px 0px rgba(87, 87, 87, 0.1);
            border: 1px solid #fff;
            .one-title {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 0.12rem;
                margin-bottom: 0.18rem;
                .one-title-left {
                    width: 73.6%;
                    background: url('../../assets/imgs/product/third-title.png')
                        no-repeat left center;
                    background-size: auto 100%;
                    font-weight: bold;
                    font-size: 0.16rem;
                    color: #293950;
                    padding-left: 0.36rem;
                    text-align: left;
                    height: 0.36rem;
                    line-height: 0.36rem;
                    box-sizing: border-box;
                }
                .one-title-right {
                    span {
                        display: inline-block;
                        width: 0.64rem;
                        height: 0.2rem;
                        background: linear-gradient(
                            180deg,
                            #32b573 0%,
                            #67d4a2 100%
                        );
                        border-radius: 0.02rem;
                        text-align: center;
                        line-height: 0.2rem;
                        font-weight: 400;
                        font-size: 0.13rem;
                        color: #ffffff;
                        vertical-align: middle;
                        margin-right: 0.2rem;
                        cursor: pointer;
                        &:hover {
                            background: #32b573;
                        }
                    }
                }
            }
            .third-list-box {
                display: flex;
                justify-content: space-between;
                padding: 0 0.2rem 0.2rem;
                .list-item {
                    width: 16%;
                    padding: 0.2rem 0 0.24rem;
                    background: rgba(255, 255, 255, 0.7);
                    border-radius: 0.08rem;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .item-cover {
                        width: 0.44rem;
                        height: 0.44rem;
                        background-image: url('../../assets/imgs/product/first-left-title.png');
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: 100% auto;
                    }
                    .item-label {
                        font-weight: bold;
                        font-size: 0.16rem;
                        color: #293950;
                        padding: 0.2rem;
                    }
                    .item-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        width: 100%;
                        .btn-opt {
                            width: 0.96rem;
                            height: 0.26rem;
                            background: #ffffff;
                            border-radius: 0.13rem;
                            border: 1px solid #c5e7cf;
                            font-size: 0.14rem;
                            text-align: center;
                            line-height: 0.26rem;
                            color: #20c164;
                            cursor: pointer;
                            &:hover {
                                background: #e9fdf4;
                            }
                            &:first-child {
                                margin-right: 0.12rem;
                            }
                            &:last-child {
                                margin-left: 0.12rem;
                            }
                        }
                    }
                    &:nth-child(2),
                    &:nth-child(3) {
                        width: 24%;
                    }
                }
            }
        }
    }
}

// 适配h5
@media screen and (max-width: 700px) {
    .product-all-box {
        .first-con-box {
            flex-direction: column;
            flex-wrap: wrap;
            padding: 0 0.15rem;
            .first-con-item {
                width: 100% !important;
                margin-bottom: 0.2rem;
                &.one,
                &.two {
                    .first-list-box {
                        flex-wrap: wrap;
                        .list-item {
                            width: 48.3%;
                            margin-bottom: 0.15rem;
                        }
                    }
                }
                &.three,
                &.four {
                    width: 100% !important;
                }
            }
        }
        .second-con-box {
            flex-direction: column;
            flex-wrap: wrap;
            padding: 0 0.15rem;
            .second-con-item {
                width: 100% !important;
                margin-bottom: 0.2rem;
                &.one {
                    .second-list-box {
                        flex-wrap: wrap;
                        .list-item {
                            width: 100% !important;
                            margin-bottom: 0.15rem;
                        }
                    }
                }
                &.three,
                &.four {
                    width: 100% !important;
                    .list-item {
                        width: 100% !important;
                    }
                }
            }
        }
        .third-con-box {
            padding: 0 0.15rem;
            .third-list-box {
                flex-wrap: wrap;

                .list-item {
                    width: 100% !important;
                    margin-bottom: 0.15rem;
                }
            }
        }

        .product-top-box {
            height: 0.55rem;
            .top-title {
                font-size: 0.2rem;
            }
            .tips-txt,
            .right-split {
                display: none;
            }
            .right-logout {
                color: #fff;
                right: 0.18rem;
            }
        }
        .unit-line-box {
            padding: 0.2rem 0.15rem;
            .unit-title {
                font-size: 0.2rem;
            }
            .unit-case {
                margin-left: 0.13rem;
            }
            &.zhijiaoH5 {
                display: block;
                padding: 0.2rem 0 0.2rem;
            }
        }
        .unit-level-box {
            padding: 0.2rem 0.15rem;
            .unit-title {
                font-size: 0.2rem;
            }
            .unit-title:last-child {
                display: none;
            }
        }
    }
}
</style>